import * as React from 'react';
import { CourseLine } from './CourseLine';
import { TableChorinitia } from '../../genericComponents/TableChorinitia/TableChorinitia';
import { Link } from 'react-router-dom';
import * as ReqType from '../../../types/ServerRequests';
import { CoursService } from '../../../services/CoursService';

/**
 * interface Props (le parametre de la classe)
 */
export interface Props {
}

/**
 * interface State (l'état interne de la classe listCourses)
 */
interface State {
    /**
     * listCourses: permet de stocker la liste des cours depuis le backend
     */
    listCourses: ReqType.Course[];
}

/**
 * Ce composant représente une liste de cours.
 * chaque ligne de ce composant correspond au courseLine
 */
export class ListCourse extends React.Component {
    props: Props;
    state: State;

    /**
     * @param {Props} props
     */
    constructor(props: Props) {
        super(props);
        this.state = {
            listCourses: [],
        };
        this.getCourses();
    }

    /**
     * @param {React.ChangeEvent<HTMLSelectElement>} e
     */
    handleselecteur = (e: React.ChangeEvent<HTMLSelectElement>) => {
        this.setState({ selecteurtrie: e.target.value });
    }

    /**
     * le rendu de la classe ListCourse
     * @returns {JSX.element}
     */
    render() {

        var listItems = this.state.listCourses.map(
            (course: ReqType.Course, index: number) => {
                return (
                    <CourseLine
                        course={course}
                        key={index}
                        changeState={this.changeCourse}
                    />
                );
            }
        );

        return (
            <div>
                <Link to="courses/newCourse">
                    <button
                        style={{marginTop: '20px', marginBottom: '20px'}}
                        className="btn btn-outline-secondary font-weight-bold"
                    >
                        Créer un Cours
                    </button>
                </Link>
                <div id="tableau">
                    <TableChorinitia
                        header={
                            <thead className="thead-light">
                                <tr>
                                    <th scope="col">Discipline</th>
                                    <th scope="col">Niveau</th>
                                    <th scope="col">Detail</th>
                                    <th scope="col">Adresse</th>
                                    <th scope="col">Consulter</th>
                                    <th scope="col" />
                                </tr>
                            </thead>
                        }
                    >
                        <tbody >
                            {listItems}
                        </tbody>
                    </TableChorinitia>
                </div>
            </div>
        );
    }

    /**
     * @returns {Promise<void>}
     */
    private getCourses() {
        CoursService.getInstance().getCoursList(
        ).then(
            (response: ReqType.Course[]) => {
                this.setState({ listCourses: response });
            }
        );
    }

    /**
     *
     * @param {Course} course
     * @returns {Promise<void>}
     */
    private changeCourse = (course: ReqType.Course) => {
        var oldCoursIndex = this.state.listCourses.findIndex(
            (courseElem: ReqType.Course) => {
                return (courseElem.id === course.id);
            }
        );
        if (oldCoursIndex !== undefined) {
            return (CoursService.getInstance().updateCours(course, this.state.listCourses[oldCoursIndex])
                .then(
                    () => {
                        this.state.listCourses[oldCoursIndex].status = course.status;
                        this.setState({ listCourses: this.state.listCourses });
                    }
                ).catch(
                    (e: object) => alert(JSON.stringify(e))
                )
            );
        } else {
            return Promise.reject('');
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/CoursesPage/internalComponents/ListCourse.tsx